import * as React from "react";
const SvgFiRrSadCry = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sad-cry_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 1.91-.456 3.791-1.328 5.49a1 1 0 1 1-1.777-.916C24.369 10.166 19.314 1.83 12 2 4.83 1.842-.225 9.855 2.949 16.258a1 1 0 1 1-1.81.851C-2.67 9.424 3.399-.189 11.999 0a12.013 12.013 0 0 1 12 12m-10.177 9.834a10.2 10.2 0 0 1-3.637 0 1 1 0 1 0-.362 1.966c1.442.264 2.92.264 4.362 0a1 1 0 0 0-.363-1.966M10 12a1 1 0 0 0 1-1c0-1.892-1.232-4-3-4s-3 2.108-3 4a1 1 0 0 0 2 0c0-1.054.679-2 1-2s1 .946 1 2a1 1 0 0 0 1 1m6-5c-1.768 0-3 2.108-3 4a1 1 0 1 0 2 0c0-1.054.679-2 1-2s1 .946 1 2a1 1 0 1 0 2 0c0-1.892-1.232-4-3-4m-4 13c2.63-.074 2.63-5.927 0-6-2.63.074-2.63 5.927 0 6m6-6a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1M6 14a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sad-cry_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSadCry;
